import { useCallback } from 'react';
import type { FormField } from './types';

const DRAFT_PREFIX = 'intake_form_draft_';

/**
 * Thin localStorage hook for auto-saving form builder state.
 * Key is `intake_form_draft_<formId>` or `intake_form_draft_new`.
 * Cleared after a successful Save Draft API call.
 */
export function useDraftState(formId: string | 'new') {
  const key = `${DRAFT_PREFIX}${formId}`;

  const load = useCallback((): FormField[] | null => {
    try {
      const raw = localStorage.getItem(key);
      return raw ? (JSON.parse(raw) as FormField[]) : null;
    } catch {
      return null;
    }
  }, [key]);

  const save = useCallback(
    (fields: FormField[]) => {
      try {
        localStorage.setItem(key, JSON.stringify(fields));
      } catch {
        /* storage full — ignore */
      }
    },
    [key],
  );

  const clear = useCallback(() => {
    localStorage.removeItem(key);
  }, [key]);

  return { load, save, clear };
}
